"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BreadCrumbs;
var _Breadcrumbs = _interopRequireDefault(require("@mui/material/Breadcrumbs/Breadcrumbs.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Link = _interopRequireDefault(require("@mui/material/Link/Link.js"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu/Menu.js"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _MoreHoriz = _interopRequireDefault(require("@mui/icons-material/MoreHoriz"));
var _react = require("react");
var _styles = require("@mui/styles");
var _ChopText = _interopRequireDefault(require("./ChopText"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(({
  palette
}) => ({
  breadCrumb: {
    '& .MuiBreadcrumbs-li': {
      maxWidth: '150px'
    }
  },
  breadCrumbActiveItem: {
    display: 'block',
    background: palette.primary.light,
    color: palette.primary.contrastText,
    borderRadius: 1,
    cursor: 'pointer',
    textDecoration: 'none',
    padding: '0 2px 0 2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  breadCrumbItem: {
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  menu: {
    padding: '5px'
  },
  menuItem: {
    paddingTop: 0,
    paddingBottom: '2px',
    paddingLeft: '5px',
    paddingRight: '5px'
  }
}));
function BreadCrumbs({
  backHistories,
  forwardHistories,
  isMobile,
  onClick
}) {
  const classes = useStyles();
  const [backAnchorEl, setBackAnchorEl] = (0, _react.useState)(null);
  const [forwardAnchorEl, setForwardAnchorEl] = (0, _react.useState)(null);
  const firstVisited = backHistories[0];
  const currentActive = backHistories[backHistories.length - 1];
  const isLastSecondVisited = forwardHistories.length === 0 && backHistories.length > 2;
  const lastSecondVisited = backHistories[backHistories.length - 2];
  const lastVisited = forwardHistories[forwardHistories.length - 1];
  const backHistoriesSlice = isLastSecondVisited && !isMobile ? backHistories.slice(1, backHistories.length - 2) : backHistories.slice(1, backHistories.length - 1);
  const forwardHistoriesSlice = isLastSecondVisited || !isMobile ? forwardHistories.slice(0, forwardHistories.length - 1) : forwardHistories;
  const backOpen = Boolean(backAnchorEl);
  const forwardOpen = Boolean(forwardAnchorEl);
  const handleHiddenBreadCrumbClick = (key, isBackward = false) => {
    onClick?.(key);
    isBackward ? setBackAnchorEl(null) : setForwardAnchorEl(null);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Breadcrumbs.default, {
      "aria-label": "breadcrumbs",
      className: classes.breadCrumb,
      children: [firstVisited && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        title: firstVisited.toolTipContext || '',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
          className: firstVisited.isCurrent ? classes.breadCrumbActiveItem : classes.breadCrumbItem,
          color: 'text.primary',
          onClick: () => onClick(firstVisited.key),
          children: firstVisited.title
        })
      }), backHistoriesSlice.length && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          color: "inherit",
          size: "small",
          onClick: e => setBackAnchorEl(e.currentTarget),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreHoriz.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.default, {
          anchorEl: backAnchorEl,
          open: backOpen,
          onClose: () => setBackAnchorEl(null),
          className: classes.menu,
          children: backHistoriesSlice?.map(item => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
            className: classes.menuItem,
            onClick: () => handleHiddenBreadCrumbClick(item.key, true),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChopText.default, {
              sx: theme => ({
                color: theme.palette.grayscale.light,
                marginRight: '5px'
              }),
              children: item.time
            }), item.title]
          }))
        })]
      }), forwardHistories.length === 0 && backHistories.length > 2 && !isMobile && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        title: lastSecondVisited.toolTipContext || '',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
          className: classes.breadCrumbItem,
          color: "text.primary",
          onClick: () => onClick(lastSecondVisited.key),
          children: lastSecondVisited.title
        })
      }), currentActive && backHistories.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        title: currentActive.toolTipContext || '',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
          className: classes.breadCrumbActiveItem,
          color: 'primary',
          onClick: () => onClick(currentActive.key),
          children: currentActive.title
        })
      }), forwardHistoriesSlice.length && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          color: "inherit",
          size: "small",
          onClick: e => setForwardAnchorEl(e.currentTarget),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreHoriz.default, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.default, {
          anchorEl: forwardAnchorEl,
          open: forwardOpen,
          onClose: () => setForwardAnchorEl(null),
          className: classes.menu,
          children: forwardHistoriesSlice?.map(item => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
            className: classes.menuItem,
            onClick: () => handleHiddenBreadCrumbClick(item.key, false),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChopText.default, {
              sx: theme => ({
                color: theme.palette.grayscale.light,
                marginRight: '5px'
              }),
              children: item.time
            }), item.title]
          }))
        })]
      }), lastVisited && !isMobile && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        title: lastVisited.toolTipContext || '',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
          className: classes.breadCrumbItem,
          color: "text.primary",
          onClick: () => onClick(lastVisited.key),
          children: lastVisited.title
        })
      })]
    })
  });
}